import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesOverview from "./components/ServicesOverview";
import ProcessSection from "./components/ProcessSection";
import WhyChooseUs from "./components/WhyChooseUs";
import Testimonials from "./components/Testimonials";
import FAQSection from "./components/FAQSection";
import ServiceAreasSection from "./components/ServiceAreasSection";
import AIAnswerBlock from "./components/AIAnswerBlock";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesOverview />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseUs />
        <Testimonials />
        <ServiceAreasSection />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
